__turbopack_context__.v({
  "accent-warm": "Hero-module-scss-module__wrjwJq__accent-warm",
  "brand": "Hero-module-scss-module__wrjwJq__brand",
  "figure": "Hero-module-scss-module__wrjwJq__figure",
  "form-container": "Hero-module-scss-module__wrjwJq__form-container",
  "hero": "Hero-module-scss-module__wrjwJq__hero",
  "hero-content": "Hero-module-scss-module__wrjwJq__hero-content",
  "hero-cta-group": "Hero-module-scss-module__wrjwJq__hero-cta-group",
  "hero-video": "Hero-module-scss-module__wrjwJq__hero-video",
  "lightblue": "Hero-module-scss-module__wrjwJq__lightblue",
  "orange": "Hero-module-scss-module__wrjwJq__orange",
  "pink": "Hero-module-scss-module__wrjwJq__pink",
  "right": "Hero-module-scss-module__wrjwJq__right",
  "simulation-form": "Hero-module-scss-module__wrjwJq__simulation-form",
  "split-hero": "Hero-module-scss-module__wrjwJq__split-hero",
  "subdued": "Hero-module-scss-module__wrjwJq__subdued",
  "title": "Hero-module-scss-module__wrjwJq__title",
  "transparent": "Hero-module-scss-module__wrjwJq__transparent",
  "with-form": "Hero-module-scss-module__wrjwJq__with-form",
  "yellow": "Hero-module-scss-module__wrjwJq__yellow",
});
